import { render, staticRenderFns } from "./jfdetail.vue?vue&type=template&id=5f69ce80&scoped=true&"
import script from "./jfdetail.vue?vue&type=script&lang=js&"
export * from "./jfdetail.vue?vue&type=script&lang=js&"
import style0 from "./jfdetail.vue?vue&type=style&index=0&id=5f69ce80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f69ce80",
  null
  
)

export default component.exports